module.exports = ".not-orderable::after {\n  content: '' !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/logs-archiving/component/logs-archiving.component.scss
// module id = ./src/app/logs-archiving/component/logs-archiving.component.scss
// module chunks = main